var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBranding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3013 17.3373C14.6583 17.3373 18.28 13.7234 18.28 9.35861C18.28 5.0016 14.6505 1.37988 10.2935 1.37988C5.92861 1.37988 2.32257 5.0016 2.32257 9.35861C2.32257 13.7234 5.93645 17.3373 10.3013 17.3373ZM7.18017 13.7156C6.99243 13.5748 6.96116 13.348 7.07067 13.0273L8.02499 10.1721L5.58444 8.42775C5.30286 8.2322 5.20116 8.0132 5.26374 7.79416C5.33413 7.58296 5.55314 7.47346 5.88952 7.47346L8.89327 7.49692L9.80848 4.62614C9.90233 4.30544 10.0666 4.13332 10.3013 4.13332C10.5359 4.13332 10.6924 4.30544 10.7941 4.62614L11.7093 7.49692L14.7052 7.47346C15.0494 7.47346 15.2527 7.58296 15.331 7.79416C15.4092 8.0132 15.2919 8.2322 15.0181 8.42775L12.5697 10.1721L13.5241 13.0273C13.6336 13.348 13.6023 13.5748 13.4223 13.7156C13.2268 13.8642 12.9999 13.8095 12.7262 13.6061L10.3013 11.8305L7.87637 13.6061C7.59475 13.8095 7.36794 13.8642 7.18017 13.7156Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranding);
export default __webpack_public_path__ + "static/media/branding.c46809f5c72a1bd6c03997ab6417a05c.svg";
export { ForwardRef as ReactComponent };